var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Viewer.email"),
        width: "750px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-radio-group",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isQuotation,
                  expression: "!isQuotation"
                }
              ],
              attrs: { no: "customerType" },
              on: {
                change: function($event) {
                  return _vm.otherHandler()
                }
              },
              model: {
                value: _vm.customerType,
                callback: function($$v) {
                  _vm.customerType = $$v
                },
                expression: "customerType"
              }
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Customer")))
              ]),
              _c("el-radio", { attrs: { label: 2 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCmp")))
              ]),
              _c("el-radio", { attrs: { label: 3 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BookingAgent")))
              ]),
              _c("el-radio", { attrs: { label: 4 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.LocalAgent")))
              ]),
              _c("el-radio", { attrs: { label: 5 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.UpDestAgent")))
              ]),
              _c("el-radio", { attrs: { label: 6 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))
              ]),
              _c("el-radio", { attrs: { label: 7 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Haulage")))
              ]),
              _c("el-radio", { attrs: { label: 8 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Warehouse")))
              ]),
              _c("el-radio", { attrs: { label: 9 } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))
              ]),
              _c("el-radio", { attrs: { label: 10 } }, [
                _vm._v(_vm._s(_vm.$t("Message.Shipper")))
              ]),
              _c("el-radio", { attrs: { label: 11 } }, [
                _vm._v(_vm._s(_vm.$t("Message.Consignee")))
              ]),
              _c("el-radio", { attrs: { label: 12 } }, [
                _vm._v(_vm._s(_vm.$t("Message.Notify")))
              ])
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "90px",
                "label-position": "left",
                inline: ""
              }
            },
            [
              !_vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long",
                      attrs: { label: _vm.$t("SeaExport.CompanyName") }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customerTypeName",
                          "method-params":
                            ((_obj = {}),
                            (_obj[_vm.customerTypeName] = true),
                            _obj),
                          "default-value": _vm.customerId || ""
                        },
                        on: { change: _vm.customerIdChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long",
                      attrs: { label: _vm.$t("SeaExport.Receiver2") }
                    },
                    [
                      _vm.source === "tabMBL" ||
                      _vm.source === "tabHBL" ||
                      _vm.source === "tabMBL2" ||
                      _vm.source === "tabHBL2"
                        ? _c(
                            "el-select",
                            {
                              attrs: {
                                no: "emailFormTo",
                                filterable: "",
                                multiple: "",
                                "allow-create": ""
                              },
                              on: {
                                clear: _vm.onClear,
                                change: _vm.emailToChange
                              },
                              model: {
                                value: _vm.emailToList,
                                callback: function($$v) {
                                  _vm.emailToList = $$v
                                },
                                expression: "emailToList"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.name }
                              })
                            }),
                            1
                          )
                        : _c("cargo-combo-box", {
                            attrs: {
                              no: "emailFormTo",
                              "allow-create": true,
                              clearable: true,
                              options: _vm.contactList,
                              "label-function": _vm.labelFunction,
                              "value-field": "email",
                              "forbid-values": [""]
                            },
                            on: { clear: _vm.onClear },
                            model: {
                              value: _vm.emailForm.to,
                              callback: function($$v) {
                                _vm.$set(_vm.emailForm, "to", $$v)
                              },
                              expression: "emailForm.to"
                            }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long placeholder-margin",
                      attrs: { label: _vm.$t("SeaExport.Receiver2") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "emailGroupTo",
                            filterable: true,
                            multiple: "",
                            clearable: true
                          },
                          on: {
                            clear: _vm.onClear,
                            change: _vm.emailGroupToChange
                          },
                          model: {
                            value: _vm.emailGroupTo,
                            callback: function($$v) {
                              _vm.emailGroupTo = $$v
                            },
                            expression: "emailGroupTo"
                          }
                        },
                        _vm._l(_vm.emailGroupToList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.groupName, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "long2",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_EmailTemplate") }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "padding-right": "15px" },
                          attrs: { no: "emailTemplate" },
                          on: { change: _vm.emailTemplateCheck },
                          model: {
                            value: _vm.emailTemplate,
                            callback: function($$v) {
                              _vm.emailTemplate = $$v
                            },
                            expression: "emailTemplate"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.EmailTemplate")))]
                      ),
                      _c("cargo-combo-box", {
                        staticStyle: { width: "420px" },
                        attrs: {
                          disabled: !_vm.emailTemplate,
                          no: "emailTemplateList",
                          "allow-create": true,
                          clearable: true,
                          options: _vm.emailTemplateList,
                          "placeholder-val": _vm.$t("SeaExport.placeholderVal"),
                          "label-function": _vm.titleLabelFunction,
                          "value-field": "uuid",
                          "forbid-values": [""]
                        },
                        on: {
                          change: function(item) {
                            _vm.emailTemplateChange("change", item)
                          },
                          clear: _vm.onClearTitle
                        },
                        model: {
                          value: _vm.emailForm.emailTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.emailForm, "emailTitle", $$v)
                          },
                          expression: "emailForm.emailTitle"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "long",
                  attrs: { label: _vm.$t("Viewer.title") }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: { no: "title" },
                        model: {
                          value: _vm.emailForm.title,
                          callback: function($$v) {
                            _vm.$set(_vm.emailForm, "title", $$v)
                          },
                          expression: "emailForm.title"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm.emailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long placeholder-margin",
                      attrs: {
                        label:
                          _vm.$t("SeaExport.Cc") +
                          _vm.$t("SeaExport.EmailGroup")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "emailGroupCc",
                            filterable: true,
                            multiple: "",
                            clearable: true
                          },
                          on: {
                            clear: _vm.onClearCc,
                            change: _vm.emailGroupCcChange
                          },
                          model: {
                            value: _vm.emailGroupCc,
                            callback: function($$v) {
                              _vm.emailGroupCc = $$v
                            },
                            expression: "emailGroupCc"
                          }
                        },
                        _vm._l(_vm.emailGroupCcList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.groupName, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "long",
                  attrs: { label: _vm.$t("SeaExport.Cc") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "emailFormCc", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.emailForm.cc,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "cc", $$v)
                      },
                      expression: "emailForm.cc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "long",
                  attrs: {
                    label: _vm.isCopyLink
                      ? _vm.$t("Viewer.BlAddress")
                      : _vm.$t("Viewer.content")
                  }
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isCopyLink,
                          expression: "isCopyLink"
                        }
                      ],
                      attrs: {
                        content: _vm.$t("Message.YouTheLinkAddressDirectly"),
                        placement: "right"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "content", type: "textarea", rows: 5 },
                        model: {
                          value: _vm.emailForm.content,
                          callback: function($$v) {
                            _vm.$set(_vm.emailForm, "content", $$v)
                          },
                          expression: "emailForm.content"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isCopyLink,
                        expression: "!isCopyLink"
                      }
                    ],
                    attrs: {
                      no: "textarea",
                      type: "textarea",
                      rows: 5,
                      label: "sefwe"
                    },
                    model: {
                      value: _vm.emailForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "content", $$v)
                      },
                      expression: "emailForm.content"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "long", staticStyle: { "margin-left": "90px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "copyLink", type: "primary" },
                      on: { click: _vm.onCopyLink }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.copyLink")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "openLink", type: "primary" },
                      on: { click: _vm.onOpenLink }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.openLink")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "sales", disabled: _vm.emailGroup },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("sales", _vm.sales)
                        }
                      },
                      model: {
                        value: _vm.sales,
                        callback: function($$v) {
                          _vm.sales = $$v
                        },
                        expression: "sales"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "op", disabled: _vm.emailGroup },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("op", _vm.op)
                        }
                      },
                      model: {
                        value: _vm.op,
                        callback: function($$v) {
                          _vm.op = $$v
                        },
                        expression: "op"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "csr", disabled: _vm.emailGroup },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("csr", _vm.csr)
                        }
                      },
                      model: {
                        value: _vm.csr,
                        callback: function($$v) {
                          _vm.csr = $$v
                        },
                        expression: "csr"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerService")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "doc", disabled: _vm.emailGroup },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("doc", _vm.doc)
                        }
                      },
                      model: {
                        value: _vm.doc,
                        callback: function($$v) {
                          _vm.doc = $$v
                        },
                        expression: "doc"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "emailGroup" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("sales", _vm.emailGroup)
                        }
                      },
                      model: {
                        value: _vm.emailGroup,
                        callback: function($$v) {
                          _vm.emailGroup = $$v
                        },
                        expression: "emailGroup"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "defaultCc", disabled: _vm.emailGroup },
                      model: {
                        value: _vm.defaultCc,
                        callback: function($$v) {
                          _vm.defaultCc = $$v
                        },
                        expression: "defaultCc"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SaveTheDefaultCC")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "long",
                  staticStyle: { height: "auto" },
                  attrs: { label: _vm.$t("SeaExport.MailContent") }
                },
                [
                  _c("quill-editor", {
                    staticClass: "my-custom-quill-editor-email-input",
                    staticStyle: { height: "auto" },
                    attrs: { options: _vm.editorOption },
                    model: {
                      value: _vm.emailForm.mailContent,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "mailContent", $$v)
                      },
                      expression: "emailForm.mailContent"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "long",
                  attrs: { label: _vm.$t("SeaExport.SendEMail") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "mailType",
                        placeholder: _vm.$t("SeaExport.SystemEmail")
                      },
                      model: {
                        value: _vm.emailForm.mailType,
                        callback: function($$v) {
                          _vm.$set(_vm.emailForm, "mailType", $$v)
                        },
                        expression: "emailForm.mailType"
                      }
                    },
                    _vm._l(_vm.sendEmailList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.localEmailClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InvokeLocalMailClient")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Send", type: "primary" },
              on: { click: _vm.okClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Send")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }